import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';
import { SignInComponent } from '../sign-in/sign-in.component';
import { LoginService } from 'src/app/_services/login.service';
import { PaymentService } from 'src/app/_services/payment.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {
  @Output() toggleSidebarForMe: EventEmitter<any> = new EventEmitter();

  screenWidth = 0;
  collapsed = false;
  firstName: any;
  lastName: any;
  constructor(
    public authService: AuthService,
    public signin: SignInComponent,
    public loginService: LoginService,
    public paymentService: PaymentService
  ) { }

  ngOnInit(): void {
    this.screenWidth = window.innerHeight;
    this.firstName = this.authService.getRegistredUserDetails().firstName;
    this.lastName = this.authService.getRegistredUserDetails().lastName;
  }

  toggleSidebar() {
    this.toggleSidebarForMe.emit();
  }

  clear() {
    this.authService.clear();
    this.paymentService.clearCache();
  }
}
